export const RELATE_ANSWER_FIELDS = {
  ANSWER_PRONOUNCE: {
    name: "answer_pronounce",
    label: "pronounce",
  },
  ANSWER_MEANING: {
    name: "answer_meaning",
    label: "meaning",
  },
};
